import { Campaign } from '../types/campaign';
import { Collab } from '../types/collab';
import {
  SCHEDULING_CAPACITY_PERIODS,
  SchedulingCapacityLimits,
} from '../types/schedulingCapacity';

export const hasAnyCapacityLimit = (limits?: SchedulingCapacityLimits | null): boolean => {
  if (!limits) return false;
  return SCHEDULING_CAPACITY_PERIODS.some(
    (period) => typeof limits[period] === 'number' && limits[period]! >= 1
  );
};

export const normalizeSchedulingCapacityLimits = (
  limits?: SchedulingCapacityLimits | null
): SchedulingCapacityLimits | null => {
  if (!limits) return null;
  const normalized: SchedulingCapacityLimits = {};
  for (const period of SCHEDULING_CAPACITY_PERIODS) {
    const value = limits[period];
    if (typeof value === 'number' && value >= 1) {
      normalized[period] = Math.floor(value);
    }
  }
  return Object.keys(normalized).length > 0 ? normalized : null;
};

export const usesOpenHoursScheduling = (
  campaign: Campaign,
  collab?: Collab | null
): boolean => {
  const collabTimes = collab?.availableTimes;
  if (collabTimes && Object.keys(collabTimes).length > 0) return false;

  const campaignTimes = campaign.availableTimes;
  if (campaignTimes && Object.keys(campaignTimes).length > 0) return false;

  if (!campaign.openHours) return false;
  return Object.values(campaign.openHours).some((hours) => (hours?.length ?? 0) > 0);
};

export const effectiveLocationHours = (
  location: { openHours?: Record<string, string[]> | null } | null | undefined,
  standard: Record<string, string[]> | null | undefined
): Record<string, string[]> => location?.openHours ?? standard ?? {};
